// ── Shared helpers for EmployeeCard and sub-components ─────────────────────

export function fmtSize(bytes) {
  if (!bytes) return '—'
  if (bytes < 1024) return `${bytes} Б`
  if (bytes < 1048576) return `${(bytes / 1024).toFixed(0)} КБ`
  return `${(bytes / 1048576).toFixed(1)} МБ`
}

// Parses both ISO format AND the Russian "DD.MM.YYYY HH:mm" format
function parseDate(str) {
  if (!str) return null
  // Try ISO first (e.g. "2026-02-25T05:16:00Z")
  const iso = new Date(str)
  if (!isNaN(iso.getTime())) return iso
  // Try "DD.MM.YYYY HH:mm" or "DD.MM.YYYY"
  const m = str.match(/^(\d{1,2})\.(\d{1,2})\.(\d{4})(?:\s+(\d{1,2}):(\d{2}))?/)
  if (m) {
    const [, d, mo, y, h = 0, mi = 0] = m
    return new Date(+y, +mo - 1, +d, +h, +mi)
  }
  return null
}

export function fmtDate(str) {
  if (!str) return '—'
  const d = parseDate(str)
  if (!d || isNaN(d.getTime())) return '—'
  return d.toLocaleDateString('ru-RU', { day: '2-digit', month: '2-digit', year: 'numeric' })
}

export function fmtDateTime(str) {
  if (!str) return '—'
  const d = parseDate(str)
  if (!d || isNaN(d.getTime())) return '—'
  return d.toLocaleString('ru-RU', {
    day: '2-digit', month: '2-digit', year: 'numeric',
    hour: '2-digit', minute: '2-digit',
  })
}

// Picks the first non-null date field from a document object
export function getDocDate(doc) {
  return doc?.created_at || doc?.upload_date || doc?.date || doc?.uploaded_at || null
}

export function fileIcon(ext) {
  const e = (ext || '').toLowerCase()
  if (e === 'pdf') return '📕'
  if (['doc', 'docx'].includes(e)) return '📝'
  if (['xls', 'xlsx'].includes(e)) return '📊'
  if (['jpg', 'jpeg', 'png', 'gif', 'webp'].includes(e)) return '🖼️'
  return '📄'
}

export function filterDocs(docs, q) {
  if (!q || !docs) return docs
  const low = q.toLowerCase()
  return docs.filter(d =>
    (d.title          || '').toLowerCase().includes(low) ||
    (d.file_name      || '').toLowerCase().includes(low) ||
    (d.description    || '').toLowerCase().includes(low) ||
    (d.employee_name  || '').toLowerCase().includes(low) ||
    (d.file_extension || '').toLowerCase().includes(low)
  )
}
